import { Avatar, Button, ButtonGroup, SkeletonText, Table, TableContainer, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import IconUserProfile from 'assets/icons/icon-user-profile.svg?react';
import ButtonRemoveResource from 'components/ButtonRemoveResource';
import ActiveTag from 'components/ui/ActiveTag';
import ButtonEdit from 'components/ui/ButtonEdit';
import DateTime from 'components/ui/DateTime';
import EmptyList from 'components/ui/EmptyList';
import Pagination from 'components/ui/Pagination';
import { usePermissionsContext } from 'contexts/PermissionsContext';
import { useServerDynamicTableContext } from 'contexts/server-table/ServerDynamicTableContext';
import { Link, useLocation } from 'react-router-dom';

export default function CompaniesList() {
  const location = useLocation();
  const { table, queryResult } = useServerDynamicTableContext();
  const companies = queryResult?.data?.items || [];
  const total = queryResult?.data?.meta?.total || 0;
  const isLoading = queryResult?.isLoading || false;
  const { ability } = usePermissionsContext();

  const hasData = total > 0;
  const hasResult = table.getRowModel().rows.length > 0;

  return (
    <SkeletonText isLoaded={!isLoading}>
      {hasResult && (
        <>
          <TableContainer>
            <Table mt="25px">
              <Thead>
                <Tr>
                  <Th>Nome</Th>
                  <Th>Status</Th>
                  <Th>Membros</Th>
                  <Th>Listas</Th>
                  <Th>Cadastrado em</Th>
                  <Th w="150px"></Th>
                </Tr>
              </Thead>
              <Tbody>
                {companies.map((company) => (
                  <Tr key={`company-${company.id}`}>
                    <Td>
                      <Avatar
                        size="sm"
                        bgColor="bg.avatar"
                        name={company.name}
                      />
                      {company.name}
                    </Td>
                    <Td>
                      <ActiveTag isActive={company.active} />
                    </Td>
                    <Td>{company._count.recipients} pessoas</Td>
                    <Td>{company._count.lists} listas</Td>
                    <Td>
                      <DateTime date={company.createdAt} />
                    </Td>
                    <Td>
                      <ButtonGroup>
                        {ability.can('edit', 'Company') ? (
                          <ButtonEdit
                            to={{
                              pathname: `/clientes/${company.id}/perfil`,
                              search: location.search,
                            }}
                          />
                        ) : (
                          <Button
                            size="sm"
                            rightIcon={<IconUserProfile />}
                            as={Link}
                            to={{
                              pathname: `/clientes/${company.id}/membros`,
                              search: location.search,
                            }}
                          >
                            Membros
                          </Button>
                        )}
                        {ability.can('delete', 'Company') && (
                          <ButtonRemoveResource
                            id={company.id}
                            pathName="companies"
                            queryKey="companies"
                          />
                        )}
                      </ButtonGroup>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
          <Pagination table={table} />
        </>
      )}

      {(!hasData || !hasResult) && (
        <EmptyList
          mt="25px"
          title={
            !hasData
              ? 'Você ainda não possui nenhum cliente cadastrado'
              : 'Nenhum resultado encontrado'
          }
          description=""
          isTable
        />
      )}
    </SkeletonText>
  )
}
